import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from '../PageContainer';
import { DefectNoticeForm } from './DefectNoticeForm';

const DefectNoticePage = ({ history }: RouteComponentProps) => {
  return (
    <PageContainer history={history}>
      <DefectNoticeForm />
    </PageContainer>
  );
};

export default DefectNoticePage;
